import React from 'react'
import styled from 'styled-components'
import { BackgroundImageWrapper, Wrapper, H, P, Grid } from '@farewill/ui'
import { screenMax, screenMin } from '@farewill/ui/helpers/responsive'
import { GTR, FONT, COLOR } from '@farewill/ui/tokens'

import PreventOrphan from 'components/PreventOrphan'

import QuoteLink from 'views/cremation/components/QuoteLinkAttended'

import data from './data'

const StyledHeading = styled(H)`
  margin-bottom: ${GTR.L};

  ${screenMin.m`
    margin-bottom: ${GTR.XL};
  `}
`

const StyledStep = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  ${screenMin.m`
    flex-direction: row;
  `}

  ${screenMin.l`
    flex-direction: column;
  `}
`

const StyledStepTextWrapper = styled.div`
  flex: 1 1 auto;
`

const StyledStepCounter = styled(BackgroundImageWrapper)`
  display: block;
  content: counter(steps);
  width: 48px;
  height: 48px;
  margin-bottom: ${GTR.S};
  font-size: ${FONT.SIZE.L};
  font-family: ${FONT.FAMILY.DECORATIVE};
  text-align: center;
  line-height: 48px;
  color: ${COLOR.BLACK};
`

const StyledStepTitle = styled(H)`
  margin-bottom: ${GTR.XS};

  ${screenMin.m`
    margin-bottom: ${GTR.S};
    font-size: ${FONT.SIZE.M};
  `};
`

const StyledGrid = styled(Grid)`
  ${screenMax.s`
    grid-column-gap: 0;
  `}
`

const SliceExpertSupport = (): React.ReactElement => (
  <Wrapper container>
    <StyledHeading centeredFromM size="L" decorative>
      {data.title}
      <br />
      {data.title2}
    </StyledHeading>

    <StyledGrid gapFromM="XL">
      {data.steps.map((step, index) => (
        <Grid.Item spanFromL={4} key={step.title}>
          <StyledStep>
            <StyledStepTextWrapper>
              <StyledStepCounter
                imagePath="textures/yellow-dot"
                imageWidth={48}
                cover
              >
                {index + 1}
              </StyledStepCounter>
              <StyledStepTitle tag="h3" size="M">
                <PreventOrphan>{step.title}</PreventOrphan>
              </StyledStepTitle>
              <P>
                <PreventOrphan>{step.description}</PreventOrphan>
              </P>
            </StyledStepTextWrapper>
          </StyledStep>
        </Grid.Item>
      ))}
    </StyledGrid>
    <Wrapper centered margin={['L', 0, 0]}>
      <QuoteLink ctaText={data.ctaLink.text} />
    </Wrapper>
  </Wrapper>
)

export default SliceExpertSupport
